import { Box } from '@mui/material';

const TicketsLine = () => {
  return (
    <Box
      sx={{
        height: 32,
        display: { xs: 'block', md: 'none' },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: -16,
          borderRadius: '50%',
          bgcolor: 'background.default',
          width: 32,
          height: 32,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          right: -16,
          borderRadius: '50%',
          bgcolor: 'background.default',
          width: 32,
          height: 32,
        }}
      />
      <Box
        sx={{
          display: 'flex',
          height: 32,
          gap: '10px',
          alignItems: 'center',
          transform: 'translateX(-6px)',
        }}
      >
        {Array.from({ length: 60 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              minWidth: 12,
              height: '1px',
              borderRadius: 4,
              bgcolor: 'background.default',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TicketsLine;
